var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('span',[_c('span',{class:[_vm.country, 'country-flag']}),(_vm.labeled)?_c('i18n',{attrs:{"path":`wgs.translationLanguage.${_vm.country}`}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }